import { FlexColumn, FlexRow, Input } from '@make-software/cspr-design';
import styled from 'styled-components';

export const ModalContainer = styled(FlexColumn)(({ theme }) => {
  return theme.withMedia({
    width: [250, 317],
    padding: 8,
    background: theme.styleguideColors.backgroundPrimary,
    borderColor: theme.styleguideColors.backgroundPrimary,
    height: 'unset',
  });
});

export const ModalHeaderRedLine = styled.div(({ theme }) =>
  theme.withMedia({
    height: 4,
    width: '100%',
    background: theme.styleguideColors.fillPrimaryRed,
    overflow: 'hidden',
  })
);

export const ModalInputRow = styled(FlexRow)(({ theme }) => {
  return theme.withMedia({
    minHeight: 60,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
  });
});

export const WarningChipContainer = styled.div(({ theme }) => {
  return theme.withMedia({
    marginLeft: 16,
    alignSelf: 'flex-start',
  });
});

export const StyledInput = styled(Input)<{ hasWarning?: boolean }>(({ theme, hasWarning }) =>
  theme.withMedia({
    height: ['32px', '36px', '36px'],
    width: ['80px', '120px'],
    div: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 600,
    },
    input: {
      color: hasWarning ? theme.styleguideColors.contentYellow : theme.styleguideColors.contentPrimary,
    },
    '[class^="input__SuffixContainer"]': {
      marginLeft: 4,
    },
    '[class^="input__InputContainer"]': {
      justifyContent: 'flex-start',
      padding: ['0 12px', '0 16px'],
    },
  })
);
